import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import UserReviews from '../../components/Users/UserReviews';
// import LikeList from '../../components/Posts/LikeList';
import PropertyDetails from '../../components/Property/PropertyDetails';
import Dashboard from '../../components/Dashboard';
import { getPropertyDetail, getReviews } from '../../redux/modules/property/action';

class ViewProperty extends React.Component {
  async componentDidMount () {
    const { dispatch, match } = this.props;
    await dispatch(getPropertyDetail(match.params.id));
    await dispatch(getReviews(match.params.id));
  }

  render () {
    const { 
      userDetails, 
      propertyDetails
    } = this.props;
    return (
      <Dashboard>
        <PropertyDetails 
          propertyDetails={propertyDetails}  
        />
        <UserReviews 
          list={propertyDetails.reviews}
        />
      </Dashboard>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    userDetails: state.user.details,
    propertyDetails: state.property.details,
    message: state.user.message
  }
}

export default connect(mapStateToProps)(ViewProperty);
